import { LogRecord } from '../../diagnostics/log-record';
import { RpcBaseData } from '../rpc-base';

/**
 * RPC log request name and version.
 */
export class RpcLogKey {
    public static command = 'Log';
    public static version = '0.1.0';
}

/**
 * Rpc log record.
 */
export interface RpcLogRecord extends LogRecord, RpcBaseData {
    /**
     * The client session ID which is auto generated when user opened the site.
     * This should be auto inserted when logging submitted to the back-end.
     */
    sessionId: string;

    /**
     * The timestamp. Date.now() / the number of milliseconds elapsed since 1 January 1970 00:00:00 UTC.
     */
    timestamp: number;
}
